import { PropsWithChildren } from 'react';

import { NotFound } from '@gasbi/shared';

import type { UserPermissionType } from '@/features/permissions';
import useCan from '@/hooks/useCan';
import usePotentialClient from '@/hooks/usePotentialClient';

type RequireRoutePermissionProps = PropsWithChildren<{
  /** At least one of these is enough, like the backend's [Permission(a, b)]. */
  permissions: UserPermissionType[];
  /**
   * A potential client has no counterparty yet, so the role gives them no data permissions, yet every
   * cabinet page stays open for them as a locked preview (PotentialClientOverlay). Set to false for a
   * page that is not part of that preview.
   */
  allowPotentialClient?: boolean;
}>;

const RequireRoutePermission = ({
  permissions,
  allowPotentialClient = true,
  children,
}: RequireRoutePermissionProps) => {
  const can = useCan();
  const { isPotentialClient, isLoading } = usePotentialClient();

  if (isLoading) return null;

  if ((allowPotentialClient && isPotentialClient) || can(...permissions)) {
    return <>{children}</>;
  }

  return <NotFound />;
};

export default RequireRoutePermission;
